<template>
  <div class="col-xs-12 col-md-6">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="motivos || []"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import MotivoService from "../../../../domain/atendimento/MotivoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-motivo",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number],
    required: Boolean,
    cursoId: null,
    login: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    motivos() {
      const motivoService = new MotivoService(this.$http);
      return motivoService
        .getMotivo()
        .then(motivos =>
          motivos.map(motivo => ({
            value: motivo.id.toString(),
            text: motivo.nome
          }))
        )
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Motivo.vue